import _extends from 'babel-runtime/helpers/extends';

export default {
  name: 'creativeInfoDialog.vue',

  props: {
    visible: {
      type: Boolean,
      default: false
    },

    action: {
      type: String,
      default: 'create',
      validator: function validator(value) {
        return ['create', 'update', 'copy'].indexOf(value) !== -1;
      }
    },

    type: {
      type: String,
      default: 'normal',
      validator: function validator(value) {
        return ['normal', 'playsmart', 'free', 'playsmartByPsd', 'iv'].indexOf(value) !== -1;
      }
    }
  },

  data: function data() {
    return {};
  },


  computed: {
    dialogAttrs: function dialogAttrs() {
      var _this = this;

      var keyPath = 'playTurbo.commonTemplate.creativeInfo';
      var actionText = {
        copy: this.$t(keyPath + '.action.copy'),
        update: this.$t(keyPath + '.action.update'),
        create: this.$t(keyPath + '.action.create')
      };

      var titleUtils = {
        normal: function normal() {
          var typeText = _this.$t(keyPath + '.type.create.normal');
          var map = {
            create: actionText[_this.action] + '-' + typeText,
            copy: _this.$t(keyPath + '.type.copy.normal')
          };
          return map[_this.action] || actionText[_this.action];
        },

        playsmart: function playsmart() {
          var typeText = _this.$t(keyPath + '.type.create.playsmart');
          var map = {
            create: actionText[_this.action] + '-' + typeText,
            copy: _this.$t(keyPath + '.type.copy.playsmart')
          };
          return map[_this.action] || actionText[_this.action];
        },

        free: function free() {
          var typeText = _this.$t(keyPath + '.type.create.playsmart');
          var map = {
            create: actionText[_this.action] + '-' + typeText,
            copy: _this.$t(keyPath + '.type.copy.playsmart')
          };
          return map[_this.action] || actionText[_this.action];
        },

        playsmartByPsd: function playsmartByPsd() {
          var typeText = _this.$t(keyPath + '.type.create.psdCreate');
          var map = {
            create: actionText[_this.action] + '-' + typeText,
            copy: _this.$t(keyPath + '.type.copy.playsmart')
          };
          return map[_this.action] || actionText[_this.action];
        },

        iv: function iv() {
          var typeText = _this.$t(keyPath + '.type.create.iv');
          var map = {
            create: actionText[_this.action] + '-' + typeText,
            copy: _this.$t(keyPath + '.type.copy.iv')
          };
          return map[_this.action] || actionText[_this.action];
        }
      };

      return _extends({
        title: titleUtils[this.type](),
        appendToBody: true,
        customClass: 'creative-info-dialog'
      }, this.$attrs);
    },


    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('update:visible', val);
      }
    }
  },

  methods: {
    handleClose: function handleClose() {
      this.$emit('handleClose');
    }
  }
};